export enum categoriesActionsTypes {
    CATEGORIES_GOT = 'CATEGORIES_GOT',
    CATEGORIES_FAILED = 'CATEGORIES_FAILED',
};